import { useRef } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import useHeaderBanner from "@/hooks/useHeaderBanner";
import useElementHeightCssVar from "@/hooks/useElementHeightCssVar";
import { HEADER_BANNER_HEIGHT_VAR, HEADER_BANNER_STYLES } from "@/constants/HeaderBanner";
import BannerBackground from "./BannerBackground";
import BannerCountdown from "./BannerCountdown";
import BannerMarquee from "./BannerMarquee";

/** Campaign strip at the top of the sticky header, configured in Magento (Header Countdown Banner). */
export default function HeaderBanner() {
  const { locale } = useRouter();
  const banner = useHeaderBanner(locale);
  const stripRef = useRef(null);
  useElementHeightCssVar(stripRef, HEADER_BANNER_HEIGHT_VAR, Boolean(banner));
  if (!banner) return null;

  const isCounter = banner.style === HEADER_BANNER_STYLES.counter;
  const hasDesktopButton = isCounter && Boolean(banner.href && banner.buttonLabel);

  return (
    <div
      ref={stripRef}
      className="group relative flex h-12 items-center overflow-hidden"
      style={{ backgroundColor: banner.colors.background, color: banner.colors.text }}
    >
      <BannerBackground images={banner.images} />
      {/* Wherever the design shows no button, the whole strip carries the link. */}
      {banner.href && (
        <Link
          href={banner.href}
          aria-label={banner.buttonLabel || banner.text || banner.items[0]}
          className={`absolute inset-0 z-10 ${hasDesktopButton ? "min-[992px]:hidden" : ""}`}
        />
      )}
      {isCounter ? (
        <BannerCountdown
          text={banner.text}
          endsAt={banner.endsAt}
          colors={banner.colors}
          href={banner.href}
          buttonLabel={banner.buttonLabel}
        />
      ) : (
        <BannerMarquee items={banner.items} speed={banner.speed} pauseOnHover={banner.pauseOnHover} />
      )}
    </div>
  );
}
